import { css } from 'linaria';

export const section = css`
  margin-top: var(--space-300);
`;
